import React from 'react'
import styled from "styled-components"

const Star = styled.span`
  color: red;
`

const RedStar = () => {
    return <Star> *</Star>
}

export default RedStar
